import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { QueryParams, QueryResult } from 'src/app/modules/core/store/models/query.model';
import { Notification } from './notifications.models';
import { MassNotification } from '@app/modules/communications/store/communications/communications.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {
  constructor(private http: HttpService) {}

  markNotificationRead(notificationUId: string): Observable<any> {
    const url = `${apiBaseUrl}/v1/notifications/messages/${notificationUId}/markRead`;

    return this.http.post(url);
  }

  getUnreadNotifications(params: QueryParams): Observable<any> {
    // const queryString = this.http.queryStringFromObject(params);
    const queryString = this.http.queryStringFromObject({
      skip: 0,
      take: 50,
      sortField: 'DateSent',
      sortDirection: 'Descending'
    });

    const url = `${apiBaseUrl}/v1/notifications/messages/unread?${queryString}`;

    return this.http.get(url);
  }

  clearAllNotifications(clearPermanent: boolean): Observable<any> {
    const url = `${apiBaseUrl}/v1/notifications/messages/markAllRead?clearPermanent=${clearPermanent}`;

    return this.http.post(url);
  }
}
